export default __webpack_public_path__ + "static/media/BelShir_Vestige_LE.b9873b85.jpg";